import useMyInfo from '@api/hooks/auth/useMyInfo';
import useSelectedGoal from '@api/hooks/topology/useSelectedGoal';
import { getMeUid } from '@api/selectors/auth';
import { getUnLiveUrl } from '@api/selectors/urls';
import useURLs from '@api/hooks/useURLs';
import useGetGroupMembersDetails from '@cont/Groups/groups-hooks/useGroupMembersDetails';
import { getMeLatestUserSubscriptions } from '@selectors/subscription';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { IGroupUser, ILeaderboardUser } from 'types/groups';

export interface IGroupsContext {
  me: { uid: any; latestUserSubscriptions: any };
  selectedGoalUID: string;
  selectedGoal: any;
  unLiveURL: string;
  groupUid?: string;
  meUserRank?: number;
  membersList?: number;
  startDate?: string;
  endDate?: string;
  currentDate?: string;
  users?: IGroupUser[];
  scoreboardData?: ILeaderboardUser[];
  leaderboardData?: ILeaderboardUser[];
  isGroupsDataLoaded: boolean;
}

export const GroupsContext = React.createContext<IGroupsContext>(null);

interface IGroupsContextProviderProps {
  children: React.ReactNode;
  goalUID: string;
  groupUID?: string;
}

export const GroupsContextProvider: React.FC<IGroupsContextProviderProps> = ({
  children,
  goalUID,
  groupUID
}) => {
  const meUid = useMyInfo(getMeUid);
  const unLiveURL = useURLs(getUnLiveUrl);
  const { selectedGoal } = useSelectedGoal();
  const { myInfo } = useMyInfo();
  const meLatestUserSubscriptions = myInfo?.latestUserSubscriptions;
  const me = {
    uid: meUid,
    latestUserSubscriptions: meLatestUserSubscriptions
  };

  const apiResults = useGetGroupMembersDetails(goalUID, groupUID);

  const data = {
    selectedGoalUID: goalUID,
    selectedGoal,
    me,
    unLiveURL,
    ...apiResults
  };

  return (
    <GroupsContext.Provider value={data}>{children}</GroupsContext.Provider>
  );
};
